import React from 'react'
import Button from 'blocks.simple/button/button'
import { api } from 'core/api/ConnectionManager'
import { addListener } from 'core/helpers'
import translate from 'core/translate'
import styles from './catalog__template_broadcastEvents.jcss'
import broadcastsHelpers from 'core/helpers/_broadcasts'
import { ItemData } from '../../../../core/models/Template'
import Toast from '../../../../blocks.simple/toast/toast'

export default {
    customParams: {
        limit: 35,
        query: '',
    },
    allowAdvancedSearch: false,
    folderName: 'folderId',
    getMethod: 'getBroadcastEvents',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noEvents'),
    mediaCellClassName: styles.mediaCellClassName,
    emptyIcon: 'not_allow',
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean) => {
        const item = { ...dataItem }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    isEqual: (item: ItemData, prevItem: ItemData) => broadcastsHelpers.isEqual(item, prevItem),
    onCreateListeners: [(cb: any, clearList: string[]) => api.addObserver('broadcastEventCreated', cb, clearList)],
    onUpdateListeners: [
        (cb: any, clearList: string[]) => api.addObserver('broadcastEventUpdated', cb, clearList),
        addListener.updateBroadcastProgress,
    ],
    onDeleteListeners: [
        (cb: any, clearList: string[]) =>
            api.addObserver('broadcastEventDeleted', ({ id }: { id: number }) => cb({ id }), clearList),
    ],
    onMultipleDeleteListeners: [
        (callback: (items: number[]) => void, clearList: string[]) => {
            api.addObserver(
                'broadcastEventDeleted',
                (response: number[]) => {
                    callback(response)
                },
                clearList
            )
        },
    ],
    isFolder: (item: ItemData) => false,
    fields: () => [
        { id: 'name', name: translate('name') },
        { id: 'eventType', name: translate('eventType') },
        { id: 'key', name: translate('key') },
        { id: 'value', name: translate('value') },
        { id: 'priority', name: translate('priority') },
        { id: 'send', name: translate('send') },
    ],
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    list: {
        name: ({ name }: { name: string }) => {
            return <div className={styles.col}>{name}</div>
        },
        eventType: ({ eventType }: { eventType: string }) => {
            return <div className={styles.col}>{translate(eventType)}</div>
        },
        key: ({ eventType, key }: { eventType: string; key: string }) => {
            return <div className={styles.col}>{translate(`${eventType}_${key}`)}</div>
        },
        value: (p_: any) => {
            return (
                <div className={styles.col}>
                    {p_.condition
                        ? translate(p_.condition.value)
                        : p_.conditionList && p_.conditionList.length
                        ? p_.conditionList[0].value
                        : null}
                </div>
            )
        },
        priority: ({ priority }: { priority: number }) => {
            const getPriorityValueToString = (value: number) => {
                switch (value) {
                    case 0:
                        return 'low'
                    case 1:
                        return 'medium'
                    case 2:
                        return 'high'
                    default:
                        return ''
                }
            }

            return <div className={styles.col}>{translate(getPriorityValueToString(priority) + 'Priority')}</div>
        },
        send: ({ id }: { id: number }) => {
            return (
                <div
                    onClick={function (e: any) {
                        e.stopPropagation()
                        e.nativeEvent.stopImmediatePropagation()

                        api.send('sendBroadcastEvent', { eventId: id }).then(() => {
                            Toast.info(translate('eventSent'), {
                                autoClose: 3000,
                                position: 'bottom-left',
                            })
                        })
                    }}
                >
                    <Button mod={'fill'}>{translate('send')}</Button>
                </div>
            )
        },
    },
}
